var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 2c-5.52245968 0-10 4.47915323-10 10 0 5.5240726 4.47754032 10 10 10 5.5224597 0 10-4.4759274 10-10 0-5.52084677-4.4775403-10-10-10zm0 4.43548387c.9353226 0 1.6935484.75822581 1.6935484 1.69354839s-.7582258 1.69354839-1.6935484 1.69354839-1.6935484-.75822581-1.6935484-1.69354839.7582258-1.69354839 1.6935484-1.69354839zm2.2580645 10.24193553c0 .2672177-.2166532.4838709-.483871.4838709h-3.548387c-.26721779 0-.48387102-.2166532-.48387102-.4838709v-.967742c0-.2672177.21665323-.4838709.48387102-.4838709h.4838709v-2.5806452h-.4838709c-.26721779 0-.48387102-.2166532-.48387102-.483871v-.9677419c0-.2672178.21665323-.483871.48387102-.483871h2.5806451c.2672178 0 .483871.2166532.483871.483871v4.0322581h.4838709c.2672178 0 .483871.2166532.483871.4838709z",
    fill: "#d3d6e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.53a7a07b.svg";
export { ForwardRef as ReactComponent };